import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface TextEditDialogData {
  /** Action buttons.  Default is ['Ok', 'Cancel'] */
  actions?: string[];
  /** Label for text box */
  label?: string;
  /** Placeholder in text box when empty */
  placeholder?: string;
  /** Initial text to edit */
  text?: string;
  /** Title of dialog box */
  title?: string;
  /** Validates input.  Ok (first) button is disabled if it returns false. */
  validFn?: (s: string) => boolean;
}

export interface TextEditDialogResult {
  /** Action button selected by the user, e.g. 'Ok' */
  selectedAction: string;
  /** Text entered by the user */
  text: string;
}

@Component({
  selector: 'text-edit-dialog',
  templateUrl: './text-edit-dialog.component.html',
})
export class TextEditDialogComponent {
  data: TextEditDialogData;

  constructor(
    public dialogRef: MatDialogRef<TextEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: TextEditDialogData
  ) {
    this.data = { ...data };
    this.data.actions = data.actions || ['Ok', 'Cancel'];
    this.data.validFn = data.validFn || ((s) => !!s);
  }

  onAction(action: string): void {
    const result = {
      selectedAction: action,
      text: this.data.text,
    } as TextEditDialogResult;
    this.dialogRef.close(result);
  }
}
